<template>
    <div class="product">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Our Brands</el-breadcrumb-item>
        </el-breadcrumb>
        <div>
            <img src="../assets/imgs/uploads/mobile/Rectangle 158.jpg" style="width: 100vw;" alt="">
        </div>
        <div class="ourbds">
            <p style="color: #303030;font-size: 5.333vw;font-weight: bold;display: flex;justify-content: center;">Our Brands
            </p>
            <p style="text-align: center;font-size: 3.467vw;color: #000;margin-top: 4.8vw;">
                Our brand emphasizes innovative, safe, and enjoyable designs, and we continuously develop our products with
                our perspective, mission, and values, driving forward the industry and benefiting society.
            </p>
        </div>
        <el-card>
            <div style="display: flex;justify-content: center;margin-bottom: 4.8vw;">
                <img src="../assets/imgs/uploads/Group 324.png" style="width: 80.939vw;height: 17.867vw; object-fit: contain;" alt="">
            </div>
            <div>
                <img src="../assets/imgs/uploads/mobile/Rectangle 217.png" style="width: 84.533vw;height: 56.533vw;" alt="">
                <router-link to="/exploreGigwi">
                    <div class="btn" style="background-color: #CA141D;">Explore</div>
                </router-link>
                <p style="text-align: center;color: #000;font-size: 4.533vw;">GiGwi, founded in 2010 in Hong Kong, has
                    always embraced a simple and sincere mission: to enrich your daily life with your cherished pets. We are
                    dedicated to fostering joy between pets and their human companions, ensuring that both can share happy
                    moments together. Our global team of designers is committed to crafting pet toys that transcend
                    boundaries, offering safe, high-quality products that cater to your pet's needs. Rooted in love and
                    companionship, we strive to be your loyal partners in pet care. Let us celebrate the bond between you
                    and your beloved pets.</p>
            </div>
        </el-card>
        <div style="padding: 9.6vw 7.733vw 15.467vw;">
            <div style="display: flex;justify-content: center;margin-bottom: 4.533vw;">
                <img src="../assets/imgs/uploads/mobile/Group 323.png" style="width: 73.867vw;height: 17.867vw;" alt="">
            </div>
            <img src="../assets/imgs/uploads/mobile/Rectangle 218.png" style="width: 84.533vw;height: 56.533vw;" alt="">
            <router-link to="/exploregp">
                <div class="btn" style="background-color: #CE9F6A;">Explore</div>
            </router-link>
            <p style="text-align: center;color: #000;font-size: 4.533vw;">Gifts for Paws is dedicated to creating a unique
                and joyful world for you and your beloved pets. Each toy is carefully designed to not only meet the play
                needs of pets but also to showcase their distinctive personalities while playing. Pets are our family and
                friends, so we not only focus on appearance but also prioritize safety and comfort. We use high-quality
                materials to ensure durability and safety. Gifts for Paws helps you establish a deeper emotional connection
                with your pets. Whether it's playing, interacting, or simply being together, we aim to enhance the bond
                between you and your beloved pets, allowing you both to enjoy each other's company to the fullest.</p>
        </div>
        <el-card>
            <div style="display: flex;justify-content: center;margin-bottom: 4.8vw;">
                <img src="../assets/imgs/uploads/mobile/Group 325.png" style="width: 80.939vw;height: 17.867vw;" alt="">
            </div>
            <div>
                <img src="../assets/imgs/uploads/mobile/mb-pkg-bg.png" style="width: 84.533vw;height: 56.533vw;" alt="">
                <router-link to="/explorepetgeek">
                    <div class="btn" style="background-color: #8DC9E9;">Explore</div>
                </router-link>
                <p style="text-align: center;color: #000;font-size: 4.533vw;">PetGeek specializing in pet toys and supplies,
                    with a vision to raise awareness of pets' needs and welfare, and to create a happier and better
                    environment for them. We offer high-quality products at affordable prices, ensuring that every pet
                    enthusiast can easily access the necessary pet supplies. Our mission is to bring joy to more pets
                    through toys, while also providing a more convenient lifestyle for both pets and their owners. Caring
                    for pets and sharing happiness is our motto.</p>
            </div>
        </el-card>
        <div style="padding: 9.6vw 7.733vw 15.467vw;">
            <div style="display: flex;justify-content: center;margin-bottom: 4.533vw;">
                <img src="../assets/imgs/uploads/xin-gigiwi.png" style="width: 80.939vw;height: 17.867vw;" alt="">
            </div>
            <img src="../assets/imgs/uploads/mobile/mb-pgk-bg.png" style="width: 84.533vw;height: 56.533vw;" alt="">
            <router-link to="/exploreskipdawg">
                <div class="btn" style="background-color: #ED6A00;">Explore</div>
            </router-link>
            <p style="text-align: center;color: #000;font-size: 4.533vw;">SKIPDAWG is dedicated to providing high-quality
                outdoor gear for your
                beloved canine companions, promoting joy and health for both owners and
                dogs in the great outdoors. We strive for every dog to freely roam and
                explore, unleashing their vitality to the fullest. Carefully selected materials
                ensure comfort and durability in SKIPDAWG products. We prioritize the
                physical and mental well-being of dogs, fostering closer bonds between
                owners and their furry friends. Our aim is to keep dogs vibrant and happy
                during outdoor activities. Embrace nature, where life continues and the
                spirit of movement never ends.
            </p>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.product {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

.ourbds {
    height: 183px;
    padding: 28px 29px 0;
    overflow: hidden;
}

.btn {
    margin: 20px 0 18px;
    height: 37px;
    line-height: 37px;
    width: 317px;
    font-size: 16px;
    font-weight: bold;
    color: #FFF;
    border-radius: 5px;
    text-align: center;
}

::v-deep .el-card {
    border-radius: 0;
}

::v-deep .el-card__body {
    padding: 34px 29px 36px;
}
</style>